var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.58 2.97054C11.58 2.97054 11.54 2.95054 11.52 2.95054C11.33 2.88054 11.12 2.90054 10.94 2.99054C10.76 3.08054 10.62 3.24054 10.55 3.43054C10.41 3.83054 10.63 4.27054 11.02 4.40054C12.81 5.10054 14.24 6.54054 14.95 8.33054C16.35 11.9005 14.59 15.9405 11.02 17.3505C7.45 18.7505 3.41 16.9905 2 13.4205C0.6 9.85054 2.36 5.81054 5.92 4.41054C5.94 4.41054 5.96001 4.39054 5.99001 4.38054C6.38001 4.21054 6.55 3.75054 6.38 3.37054C6.3 3.18054 6.15001 3.04054 5.96001 2.97054C5.77001 2.90054 5.56 2.90054 5.38 2.98054C2.11 4.26054 0 7.36054 0 10.8705C0 15.5505 3.81 19.3505 8.48 19.3505C10.75 19.3505 12.88 18.4705 14.48 16.8705C16.08 15.2705 16.96 13.1405 16.97 10.8705C16.98 7.40054 14.82 4.23054 11.6 2.98054L11.58 2.97054Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.44022 11.8505C8.89022 11.8705 9.27021 11.5105 9.29021 11.0605C9.29021 11.0405 9.29021 11.0205 9.29021 11.0005V1.0805C9.29021 0.630498 8.92022 0.260498 8.47022 0.260498C8.02022 0.260498 7.65021 0.630498 7.65021 1.0805V11.0005C7.63021 11.4505 7.99022 11.8305 8.44022 11.8505Z",
    fill: "#26B963"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d6e5a86afe82418e8d5d32cee5f31e7f.svg";
export { ForwardRef as ReactComponent };